<template>

  <div class="schema_ae">
    <b-row
      class="content-header"
    >

      <!-- Content Left -->
      <b-col
        class="content-header-left mb-2"
        cols="12"
        md="12"
      >
        <b-row class="breadcrumbs-top">
          <b-col cols="12">
            <h1 class="custom-header-title float-left pr-1 mb-0">
              Create new Scheme
            </h1>
          </b-col>
        </b-row>
      </b-col>
    </b-row>

    <!-- Table Container Card -->
    <b-form @submit.prevent="submitForm">
      <validation-observer
        ref="schemeCreateForm"
        #default="{invalid}"
      >
        <b-card
          header-tag="header"
        >
          <b-row>
            <b-col cols="md-12">
              <b-form-group
                label="Scheme Name*"
                label-for="h-scheme-name"
                label-cols-md="2"
              >
                <validation-provider
                  #default="{ errors }"
                  name="Scheme Name"
                  vid="name"
                  rules="required"
                >
                  <b-form-input
                    id="h-scheme-name"
                    v-model="name"
                    placeholder="Enter a name for the scheme"
                    :state="(errors.length > 0 || nameValidation) ? false : null"
                    name="name"
                    @input="nameValidation == true ? nameValidation = false : null"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                  <small
                    v-if="nameValidation"
                    class="text-danger"
                  >
                    {{ nameError }}
                  </small>
                </validation-provider>
              </b-form-group>
            </b-col>

            <b-col cols="md-12">
              <b-form-group
                label="Internal Remarks"
                label-for="h-scheme-remarks"
                label-cols-md="2"
              >
                <validation-provider
                  #default="{ errors }"
                  name="Internal Remarks"
                  vid="remarks"
                  rules=""
                >
                  <b-form-textarea
                    id="h-remarks"
                    v-model="remarks"
                    placeholder="Remarks"
                    :state="(errors.length > 0 || remarksValidation) ? false : null"
                    name="remarks"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                  <small
                    v-if="remarksValidation"
                    class="text-danger"
                  >
                    {{ remarksError }}
                  </small>
                </validation-provider>
              </b-form-group>
            </b-col>

            <b-col cols="md-12">
              <validation-provider
                #default="{ errors }"
                name="Status"
                vid="status"
                rules="required"
              >
                <b-form-group
                  label="Status*"
                  label-for="h-scheme-status"
                  label-cols-md="2"
                  :state="(errors.length > 0 || statusValidation) ? false : null"
                >
                  <div class="width50">
                    <v-select
                      id="h-scheme-status"
                      v-model="status"
                      label="title"
                      :options="statusOptions"
                      :reduce="title => title.code"
                      :clearable="false"
                      @input="statusValidation == true ? statusValidation = false : null"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                    <small
                      v-if="statusValidation"
                      class="text-danger"
                    >
                      {{ statusError }}
                    </small>
                  </div>
                </b-form-group>
              </validation-provider>
            </b-col>
          </b-row>
        </b-card>

        <b-card
          header-tag="header"
          body-class="scheme-create-body"
        >
          <template #header>
            <b-button
              v-ripple.400="'rgba(255, 255, 255, 0.15)'"
              type="button"
              variant="flat-primary"
              class="primary-button-with-background mr-3"
            >
              <feather-icon
                icon="GridIcon"
                class=""
                size="20"
              />
            </b-button>
            <h3 class="align-middle mr-auto">
              Entitlements Issuance Condition(s)
            </h3>
          </template>
          <p class="entitle-scheme-heading">
            Entitlements are issued every time <strong class="weight-700">one</strong> of the following conditions are met (with all criteria within the condition met).
          </p>
          <b-card-body>
            <b-row
              v-for="(field, index) in conditions"
              :key="index"
              ref="row"
            >
              <b-col cols="md-12">
                <validation-provider
                  #default="{ errors }"
                  name="Component Type"
                  vid="componentType"
                  rules="required"
                >
                  <b-form-group
                    :label="'Condition #' + (index + 1) + '*'"
                    :label-for="'h-activity-type-input-type' + index"
                    label-cols-md="2"
                    :state="(errors.length > 0 || field.conditionInvalid) ? false : null"
                  >
                    <v-select
                      :id="'h-activity-type-input-type' + index"
                      v-model="field.condition"
                      label="title"
                      placeholder="Select a condition"
                      :options="inputTypeOptions"
                      :reduce="title => title.code"
                      :clearable="false"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                    <small
                      v-if="field.conditionInvalid"
                      class="text-danger"
                    >
                      {{ field.conditionInvalidMessage }}
                    </small>
                  </b-form-group>
                </validation-provider>
              </b-col>
              <b-col cols="md-12">
                <b-form-group
                  label="Sales Submission Date"
                  :label-for="'h-task-block-extraOptions' + index"
                  label-cols-md="2"
                >
                  <div
                    class="d-flex align-items-start"
                    style="gap: 10px;"
                  >
                    <div class="width50">
                      <!-- Start Date -->
                      <validation-provider
                        #default="{ errors }"
                        name="Start Date"
                        :vid="'startDate-' + index"
                      >
                        <b-input-group>
                          <flat-pickr
                            :id="'h-task-start-date-label' + index"
                            v-model="field.startDate"
                            class="form-control flat-pickr-group"
                            placeholder="Select Start Date"
                            :config="flatPickrConfigWithoutTime"
                          />
                          <b-input-group-append is-text>
                            <feather-icon
                              icon="CalendarIcon"
                              class="cursor-pointer"
                              data-toggle
                              size="18"
                            />
                          </b-input-group-append>
                        </b-input-group>
                        <small class="text-danger">{{ errors[0] }}</small>
                      </validation-provider>
                    </div>
                    <div class="width50">
                      <!-- End Date -->
                      <validation-provider
                        #default="{ errors }"
                        name="End Date"
                        :vid="'endDate-' + index"
                      >
                        <b-input-group style="margin-left: 5px;">
                          <flat-pickr
                            :id="'h-task-end-date-label' + index"
                            v-model="field.endDate"
                            class="form-control flat-pickr-group"
                            placeholder="Select End Date"
                            :config="flatPickrConfigWithoutTime"
                          />
                          <b-input-group-append is-text>
                            <feather-icon
                              icon="CalendarIcon"
                              class="cursor-pointer"
                              data-toggle
                              size="18"
                            />
                          </b-input-group-append>
                        </b-input-group>
                        <small class="text-danger">{{ errors[0] }}</small>
                      </validation-provider>
                    </div>
                  </div>

                  <small class="text-muted-999">
                    Sales Orders submitted during this period will be applicable to receive entitlements. Leave blank to issue entitlements without a time window.
                  </small>
                </b-form-group>
              </b-col>
              <b-col cols="md-12">
                <validation-provider
                  #default="{ errors }"
                  name="Applicable Core Product(s)"
                  vid="inventory"
                  rules="required"
                >
                  <b-form-group
                    label="Applicable Core Product(s)*"
                    label-for="inventory"
                    label-cols-md="2"
                    :state="(errors.length > 0 || field.inventoryValidation) ? false : null"
                  >
                    <v-select
                      :id="'h-task-inventory-item-label' + index"
                      v-model="field.inventoryItems"
                      label="name"
                      placeholder="Choose from list"
                      :options="storeOptions"
                      :reduce="name => name._id"
                      :clearable="true"
                      multiple
                      @input="field.inventoryValidation == true ? field.inventoryValidation = false : null"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                    <small
                      v-if="field.inventoryValidation"
                      class="text-danger"
                    >
                      {{ field.inventoryError }}
                    </small>
                    <small class="text-muted-999">A Sales Order must contain <b>at least one</b> of the selected products to be eligible to receive entitlement(s).</small>
                  </b-form-group>
                </validation-provider>
              </b-col>
              <b-col
                v-if="conditions.length > 1"
                cols="12"
              >
                <p
                  class="removeText"
                  @click="removeCustomField(index)"
                >
                  Remove this condition
                </p>
              </b-col>
              <b-col
                v-if="index >= 0 && index < conditions.length - 1"
                cols="12"
              >
                <hr class="dividerHR">
              </b-col>
            </b-row>
          </b-card-body>
          <div class="scheme-condition-add">
            <b-button
              v-ripple.400="'rgba(255, 255, 255, 0.15)'"
              type="button"
              variant="primary"
              @click="addCustomField"
            >
              <feather-icon
                icon="PlusIcon"
                class="mr-50"
                size="16"
              />
              <span class="align-middle">Add Condition</span>
            </b-button>
          </div>
        </b-card>

        <b-nav class="wrap-border save-nav">
          <li
            class="nav-item ml-auto"
          >
            <b-button
              v-ripple.400="'rgba(255, 255, 255, 0.15)'"
              type="button"
              variant="flat-primary"
              :to="{ name: 'products-schemes-index', params: { type: 'all-scheme' } }"
            >
              Cancel
            </b-button>
          </li>
          <li
            class="nav-item mr-1"
          >
            <b-button
              v-ripple.400="'rgba(255, 255, 255, 0.15)'"
              type="submit"
              variant="success"
              :disabled="invalid"
            >
              <feather-icon
                icon="PlusIcon"
                class="mr-50"
              />
              <span class="align-middle">Create new Scheme</span>
            </b-button>
          </li>
        </b-nav>
      </validation-observer>
    </b-form>
  </div>
</template>

<script>
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import {
  BCard, BRow, BCol, BFormGroup, BFormInput, BFormTextarea, BForm, BButton, BNav, BInputGroup,
  BInputGroupAppend, BCardBody,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import vSelect from 'vue-select'
import flatPickr from 'vue-flatpickr-component'
import 'vue2-dropzone/dist/vue2Dropzone.min.css'
import { required } from '@validations'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import '@core/scss/vue/libs/vue-flatpicker.scss'

export default {
  components: {
    BCard,
    BRow,
    BCol,
    BFormGroup,
    BFormInput,
    BFormTextarea,
    BForm,
    BButton,
    BNav,
    BInputGroup,
    BInputGroupAppend,
    BCardBody,

    flatPickr,
    vSelect,
    // eslint-disable-next-line vue/no-unused-components
    ToastificationContent,
    ValidationProvider,
    ValidationObserver,
  },
  directives: {
    Ripple,
  },
  data() {
    return {
      name: '',
      remarks: '',
      status: 'active',
      nameError: 'Scheme Name is required',
      remarksError: 'Internal Remarks is required',
      nameValidation: false,
      remarksValidation: false,
      statusValidation: false,
      statusError: 'Valid status is required',
      statusOptions: [
        { title: 'Active', code: 'active' },
        { title: 'Inactive', code: 'inactive' },
        { title: 'Expired', code: 'expired' },
      ],
      conditions: [{
        condition: '',
        startDate: '',
        endDate: '',
        conditionInvalid: false,
        conditionInvalidMessage: '',
        inventoryItems: [],
        inventoryValidation: false,
        inventoryError: '',
      }],
      inputTypeOptions: [
        { title: 'A Sales Order is approved', code: 'A Sales Order is approved' },
      ],
      storeOptions: [],
      // validation rules
      required,
      flatPickrConfigWithoutTime: {
        wrap: true, enableTime: false, dateFormat: 'd/m/Y', disableMobile: true,
      },
    }
  },

  beforeMount() {
    this.$http.get('inventory/item/respond-with/name-and-id')
      .then(response => {
        this.storeOptions = response.data.stores
      })
      .catch(error => {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: error.data.message ?? process.env.VUE_APP_DEFAULT_ERROR_MESSAGE,
            icon: 'AlertTriangleIcon',
            variant: 'danger',
          },
        })
      })
  },
  methods: {
    removeCustomField(index) {
      this.conditions.splice(index, 1)
    },
    addCustomField() {
      this.conditions.push({
        condition: '',
        startDate: '',
        endDate: '',
        conditionInvalid: false,
        conditionInvalidMessage: '',
        inventoryItems: [],
        inventoryValidation: false,
        inventoryError: '',
      })
    },
    submitForm() {
      this.$refs.schemeCreateForm.validate().then(success => {
        if (success) {
          const formData = new FormData()

          formData.append('name', this.name)
          formData.append('remarks', this.remarks)
          formData.append('status', this.status)

          const trimmedData = this.conditions.map(field => {
            const properties = {
              condition: field.condition,
              startDate: field.startDate,
              endDate: field.endDate,
              inventoryItems: field.inventoryItems,
            }
            return properties
          })
          formData.append('conditions', JSON.stringify(trimmedData))

          this.$http.post('reservation/entitlement-schemes/store', formData, {
            headers: { 'Content-Type': 'multipart/form-data' },
          })
            .then(response => {
              this.$swal({
                title: 'Scheme Created',
                html: `New scheme <strong>${this.name}</strong> has been created successfully.`,
                // eslint-disable-next-line global-require
                imageUrl: require('@/assets/images/icons/save.png'),
                imageWidth: 80,
                imageHeight: 80,
                imageAlt: 'Custom Icon',
                showCancelButton: true,
                reverseButtons: true,
                cancelButtonText: 'Return to Schemes',
                allowOutsideClick: false,
                confirmButtonText: 'View Entry',
                customClass: {
                  confirmButton: 'btn btn-primary ml-1',
                  cancelButton: 'btn btn-outline-primary',
                },
                buttonsStyling: false,
                width: 500,
              })
                .then(result => {
                  if (result.value) {
                    this.$router.push({ name: 'products-schemes-show', params: { id: response.data.data._id } })
                  } else {
                    this.$router.push({ name: 'products-schemes-index', params: { type: 'all-scheme' } })
                  }
                })
            })
            .catch(error => {
              if (error.data.errors) {
                error.data.errors.forEach(validationError => {
                  if (validationError.param === 'name') {
                    this.nameError = validationError.msg
                    this.nameValidation = true
                  } else if (validationError.param === 'remarks') {
                    this.remarksError = validationError.msg
                    this.remarksValidation = true
                  } else if (validationError.param === 'status') {
                    this.statusError = validationError.msg
                    this.statusValidation = true
                  }
                })

                const items = document.getElementsByClassName('text-danger')
                window.scrollTo({
                  top: items[0].offsetTop,
                  behavior: 'smooth',
                })
              } else {
                this.$toast({
                  component: ToastificationContent,
                  props: {
                    title: error.data.message ?? process.env.VUE_APP_DEFAULT_ERROR_MESSAGE,
                    icon: 'AlertTriangleIcon',
                    variant: 'danger',
                  },
                })
              }
            })
        }
      })
    },
  },
}
</script>

<style lang="scss">
.removeText {
  color:#D91B35;
  cursor: pointer;
}
</style>
